exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".static-pages .cke_chrome {\n  border: none; }\n\n.static-pages .initial-border {\n  border: 1px solid #d1d1d1; }\n\n.static-pages .border-on-error {\n  border: 1px solid red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-2!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/app/style/manageTermsPolicyAndContact.scss
// module id = 1885
// module chunks = 0